"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compositionsDropdownMenu = require("@eig-builder/compositions-dropdown-menu");

var _compositionsActionButton = _interopRequireDefault(require("@eig-builder/compositions-action-button"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _styles = require("@eig-builder/core-ui/styles");

var _constants = require("./../constants");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    actionButton: {
      color: theme.palette.primary.main,
      border: "1px ".concat(theme.palette.primary.main, " solid"),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(3),
      height: '38px',
      width: '38px'
    },
    deleteReply: {
      color: theme.palette.red.main,
      borderTop: "1px ".concat(theme.palette.black.lighter, " solid")
    }
  };
});
var dataElementLabel = 'gmb.review.reply.dropdown.menu';

var KebabMenu = function KebabMenu(_ref) {
  var fireCallBack = _ref.fireCallBack,
      showDelete = _ref.showDelete;
  var classes = useStyles();
  var items = [/*#__PURE__*/_react["default"].createElement(_compositionsDropdownMenu.DropdownMenuItem, {
    key: "flag-review",
    onClick: function onClick() {
      return fireCallBack(_constants.CALLBACK_ACTIONS.FLAG_REVIEW);
    },
    dataElementLabel: dataElementLabel,
    dataElementId: "gmb--reviews-menu--flag-review",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "helpers.gmbWithCustomFocusNavigation.kebabMenu.flagReview"
  }))]; // TODO: add reviewReplied && !isLoadingDelete check

  showDelete && items.push( /*#__PURE__*/_react["default"].createElement(_compositionsDropdownMenu.DropdownMenuItem, {
    onClick: function onClick() {
      return fireCallBack(_constants.CALLBACK_ACTIONS.DELETE_REPLY);
    },
    className: classes.deleteReply,
    dataElementLabel: dataElementLabel,
    dataElementId: "gmb--reviews-menu--delete-review",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "helpers.gmbWithCustomFocusNavigation.kebabMenu.deleteYourReply"
  })));
  return /*#__PURE__*/_react["default"].createElement(_compositionsDropdownMenu.DropdownMenu, {
    children: items,
    actionElement: /*#__PURE__*/_react["default"].createElement(_compositionsActionButton["default"], {
      dataElementLabel: dataElementLabel,
      dataElementId: "gmb--review--menu-dropdown",
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      className: classes.actionButton,
      marginSides: "0",
      margin: "0",
      padding: "0",
      icon: "more_vert"
    })
  });
};

KebabMenu.propTypes = {
  fireCallBack: _propTypes["default"].func.isRequired,
  showDelete: _propTypes["default"].bool
};
var _default = KebabMenu;
exports["default"] = _default;